import { render, staticRenderFns } from "./centurion-lifestyle.vue?vue&type=template&id=2cb300cc&scoped=true&"
import script from "./centurion-lifestyle.vue?vue&type=script&lang=js&"
export * from "./centurion-lifestyle.vue?vue&type=script&lang=js&"
import style0 from "./centurion-lifestyle.vue?vue&type=style&index=0&id=2cb300cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb300cc",
  null
  
)

export default component.exports